import { loadKeyPools } from '../actions/skuActions';
const steamToolUriScheme =
  (window as any).globalConfig?.steamToolUriScheme ??
  process.env.REACT_APP_STEAM_TOOL_URI_SCHEME ??
  'alaska';

export function steamRequestKeysUri(id: string) {
  return `${steamToolUriScheme}:requestKeys:${id}`;
}
export function steamDisableKeysUri(
  id: string,
  banType: string | undefined,
  reason: string | undefined
) {
  return `${steamToolUriScheme}:disableKeys:${id}:${banType}:${reason}`;
}

export interface GameWithSkus {
  gameId: string;
  gameName: string;
  skus: string[];
}

export async function populateSkuKeyPools(games: GameWithSkus[]) {
  const skuKeyPools = [];
  for (const game of games) {
    for (const skuId of game.skus) {
      skuKeyPools.push(
        loadKeyPools({
          id: skuId,
          gameid: game.gameId,
          filters: [],
          _sort: 'KeyWorkflowName',
          _order: '',
          _page: 1,
          _limit: 100,
          _scopes: [],
        })
      );
    }
  }
  //Wait for all of the promises to resolve
  interface KeyPoolDataRow {
    skuId: string;
    skuName: string;
    gameName: string;
    packageTypeId: string;
    keyWorkflowIsDeleted?: boolean;
    keyWorkflowId: string;
    keyWorkflowName: string;
    keyProviderReference: string;
  }
  const skus: {
    id: string;
    name: string;
    gameName: string;
    packageTypeId: string;
    keyPools: { keyWorkflowId: string; keyWorkflowName: string; keyProviderReference: string }[];
  }[] = [];
  const results = await Promise.all(skuKeyPools);

  for (const result of results) {
    for (const row of result.data as KeyPoolDataRow[]) {
      let sku = skus.find((x) => x.id === row.skuId);
      if (!row.keyWorkflowIsDeleted) {
        const keyPoolRow = {
          keyWorkflowId: row.keyWorkflowId,
          keyWorkflowName: row.keyWorkflowName,
          keyProviderReference: row.keyProviderReference,
        };
        if (sku) {
          sku.keyPools.push(keyPoolRow);
        } else {
          skus.push({
            id: row.skuId,
            name: row.skuName,
            gameName: row.gameName,
            packageTypeId: row.packageTypeId,
            keyPools: [keyPoolRow],
          });
        }
      }
    }
  }
  return skus;
}
